// 将来的にはこのファイル（コンポーネント）ごといらなくなるかも
// ページを切り替えたときに位置を記憶しておきたいという要望もあるから
// 現状では不自然さをとりのぞくために追加している

import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = ({ children }) => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location])

  return children
}

export default ScrollToTop
